import React from "react";
import Fonts from "../../../../Config/Fonts";
import Icons from "../../../../Config/Images";
import Colors from "../../../../theme/Colors";

const ProductCategoryTableBody = ({
  prodCategoryDetails,
  onViewProductCategoryDetails,
  onEditProductCategoryDetails,
  handleShowDeleteModal,
}) => {
  return (
    <tbody>
      {prodCategoryDetails?.map((prod, index) => (
        <tr key={index}>
          <td component="th" style={tableDataInputStyle}>
            {index + 1}
          </td>
          <td component="th" style={tableDataInputStyle}>
            {prod?.product_category_name}
          </td>
          <td align="right" style={tableDataInputStyle}>
            <img
              src={Icons.viewIcon}
              style={{
                height: "20px",
                width: "20px",
                cursor: "pointer",
              }}
              onClick={() => onViewProductCategoryDetails(prod)}
              alt="Preview Icon"
            />
            <img
              src={Icons.editIcon}
              style={{
                height: "20px",
                width: "20px",
                cursor: "pointer",
                marginLeft: "20px",
              }}
              onClick={() => onEditProductCategoryDetails(prod)}
              alt="edit Icon"
            />
            <img
              src={Icons.trashIcon}
              style={{
                height: "20px",
                width: "20px",
                cursor: "pointer",
                marginLeft: "20px",
              }}
              onClick={() => handleShowDeleteModal(prod?.product_category_id)}
              alt="Delete Icon"
            />
          </td>
        </tr>
      ))}
    </tbody>
  );
};

const tableDataInputStyle = {
  fontSize: 12,
  fontWeight: 500,
  fontFamily: Fonts.Poppins,
  color: Colors.black,
  textAlign: "center",
  padding: "8px 10px",
  border: "1px solid #E6E6E6",
};

export default ProductCategoryTableBody;
